var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.625 1.45354C0.624928 1.23772 0.680737 1.02556 0.786994 0.837705C0.893251 0.649853 1.04633 0.492712 1.23134 0.381581C1.41635 0.270449 1.62699 0.209112 1.84274 0.203542C2.05849 0.197971 2.272 0.248356 2.4625 0.349792L18.5475 8.89604C18.7478 9.00252 18.9154 9.1615 19.0322 9.35594C19.1491 9.55037 19.2108 9.77295 19.2108 9.99979C19.2108 10.2266 19.1491 10.4492 19.0322 10.6437C18.9154 10.8381 18.7478 10.9971 18.5475 11.1035L2.46125 19.6498C2.2707 19.751 2.0572 19.8011 1.84153 19.7953C1.62585 19.7896 1.41535 19.7281 1.23049 19.6168C1.04563 19.5056 0.892706 19.3484 0.786603 19.1605C0.6805 18.9727 0.624827 18.7605 0.625 18.5448V12.9123C0.624979 12.6207 0.726929 12.3382 0.913202 12.1138C1.09947 11.8894 1.35835 11.7372 1.645 11.6835L10.625 9.99979L1.645 8.31604C1.35835 8.26238 1.09947 8.11018 0.913202 7.88578C0.726929 7.66139 0.624979 7.37893 0.625 7.08729V1.45354Z",
    fill: "#E5322D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.bab6ccf93e096abb621d753fd56c842d.svg";
export { ForwardRef as ReactComponent };